module.exports = __webpack_public_path__ + "static/media/syncinfo.f8f9ebde.png";